var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2291 18.2916H3.64579C2.63902 18.2916 1.82288 17.4755 1.82288 16.4687V5.45193C1.86536 4.47626 2.6692 3.70739 3.64579 3.70831H18.2291C19.2359 3.70831 20.052 4.52446 20.052 5.53123V16.4687C20.052 17.4755 19.2359 18.2916 18.2291 18.2916ZM3.64579 7.23384V16.4687H18.2291V7.23384L10.9375 12.0937L3.64579 7.23384ZM4.37496 5.53123L10.9375 9.90623L17.5 5.53123H4.37496Z",
    fill: "#79819A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b0c101ce33a0b21c8c8c931c52e938e6.svg";
export { ForwardRef as ReactComponent };